import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

import { convertirTextAMomentUTC, MASCARA_DDMMYYYY, MASCARA_YYYYMMDD } from '../../commons/gestioDates';
import { textQuanNoHiHaDada } from '../../constants';

/**
 * Rep per paràmetre un string amb una data amb una màscara(que entengui moment), i retorna
 * la mateixa data com string en format DD-MM-YYYY.
 * @param {string} dataAsString
 */
const generarDataPerVisualitzar = (dataAsString) => {
    let data = null;

    if (dataAsString) {
        const dataAsMoment = convertirTextAMomentUTC(dataAsString, MASCARA_YYYYMMDD);
        data = dataAsMoment.format(MASCARA_DDMMYYYY);
    }

    return data;
};

/**
 * Renderitza una llista de usuaris amb el nom i els cognoms
 * @param {Array} observadors
 */
const renderObservadors = (observadors) => {

    if (!observadors || observadors.length === 0) return textQuanNoHiHaDada;

    const llistaObservadors =  observadors.map((usuariActiu, index) => {
        return (
            <li key={index}>
                {usuariActiu.nom} {usuariActiu.cognom1} {usuariActiu.cognom2}
            </li>
        );
    });

    return (<ul>{llistaObservadors}</ul>);
};

const EstacioDetallDadesBasiques = (props) => {
    const { observadorsActius } = props;
    const { codi, nom, dataAlta, dataBaixa, codiTipusEstacio, codiAEMET, operativa } = props.dadesBasiques;

    const dataAltaDDMMYYYY = generarDataPerVisualitzar(dataAlta);
    const dataBaixaDDMMYYYY = generarDataPerVisualitzar(dataBaixa);

    const nomCognomsObservadorsActius = renderObservadors(observadorsActius);

    return (
        <div className='estacio-detall-dades-basiques'>
            <div>
                <div><span>Codi: </span>{codi}</div>
                <div><span>Nom: </span>{nom}</div>
                <div><span>Tipus: </span>{codiTipusEstacio || textQuanNoHiHaDada}</div>
                <div><span>Data alta: </span>{dataAltaDDMMYYYY || textQuanNoHiHaDada}</div>
                <div><span>Data baixa: </span>{dataBaixaDDMMYYYY || textQuanNoHiHaDada}</div>
            </div>
            <div>
                <span>Observadors actius: </span>
                {nomCognomsObservadorsActius}
            </div>
            <div className='estacio-detall-dades-basiques-codiAemet-operativa'>
                <div>
                    <div><span>Codi AEMET: </span>{codiAEMET || textQuanNoHiHaDada}</div>
                    <div>
                        <span>Operativa: </span>
                        <Checkbox disabled={true} checked={operativa} />
                    </div>
                </div>
            </div>
        </div>
    );
};

EstacioDetallDadesBasiques.propTypes = {
    dadesBasiques: PropTypes.object,
    observadorsActius: PropTypes.array
};

export default EstacioDetallDadesBasiques;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetallDadesBasiques.js